<!--
    计费中心-账户流水
    功能：展示现金流水列表数据
    组件：AppList，AppSearch
-->
<template>
  <div class="water_list">
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="现金流水" name="cash">
<!--
          excelLabel="导出excel表"-->
        <AppList
          v-if="activeName === 'cash'"
          ref="list"
          :list.sync="list_first"
          title=""
          :api="cashApiUrl">
          <AppSearch
            slot="search"
            :order="{ type: 'id', name: 'desc'}"
            :search-arr="searchArrFirst"/>
          <template slot-scope="props">
            <el-table :data="props.listData">
              <el-table-column
                v-for="column in columns_cash"
                :key="column.prop"
                :prop="column.prop"
                :label="column.label"
                :width="column.width"
                :formatter="column.formatter"
              />
              <el-table-column
                label="操作"
                width="160px"
                class="orgin-btn"
              >
                <template slot-scope="scope">
                  <template v-if="scope.row.action === 'in'">
                    <el-link
                      v-if="$store.state.from === 'schoolCenter'"
                      @click="detail(scope.row)"
                    >付款信息</el-link>
                    <el-button
                      v-else
                      size="small"
                      @click="detail(scope.row)"
                    >付款信息</el-button>
                  </template>
                  <span v-else>--</span>
                </template>
              </el-table-column>
            </el-table>
          </template>
        </AppList>
      </el-tab-pane>
      <el-tab-pane label="金币流水" name="gold">
<!--
          excelLabel="导出excel表"-->
        <AppList
          v-if="activeName === 'gold'"
          ref="list"
          :list.sync="list_second"
          title=""
          :api="goldApiUrl">
          <AppSearch
            slot="search"
            :order="{ type: 'id', name: 'desc'}"
            :search-arr="searchArrSecond"/>
          <template slot-scope="props">
            <el-table :data="props.listData">
              <el-table-column
                v-for="column in columns_gold"
                :key="column.prop"
                :prop="column.prop"
                :label="column.label"
                :width="column.width"
                :formatter="column.formatter"
              />
              <el-table-column
                label="操作"
                width="100px"
                class="orgin-btn">
                <template slot-scope="scope">
                  <template v-if="scope.row.action === 'in'">
                    <el-link
                      v-if="$store.state.from === 'schoolCenter'"
                      @click="detail(scope.row)"
                    >付款信息</el-link>
                    <el-button
                      v-else
                      size="small"
                      @click="detail(scope.row)"
                    >付款信息</el-button>
                  </template>
                  <span v-else>--</span>
                </template>
              </el-table-column>
            </el-table>
          </template>
        </AppList>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
  import baseUrl from "../../utils/api";
  import merge from 'webpack-merge';

  export default {
    name: "Waterlist",
    data() {
      return {
        activeName: 'cash',
        cashApiUrl: '',
        goldApiUrl: '',
        columns_cash: [],
        columns_gold: [],
        list_first: {},
        list_second: {},
      }
    },
    computed: {
      school() {
        return this.$store.state.choicesSchool
      },
      searchArrFirst() {
        const column = [
          { prop: 'flow_on', label: '流水号' }
        ];
        return [
          {
            componentType: 'AppSearchDate',
            searchType: 'created_at',
          },
          {
            selectValue: [
              { value: 'in', name: ' 收入 ' },
              { value: 'out', name: ' 支出 ' }
            ],
            componentType: 'AppSearchStatusString',
            searchType: 'action',
            placeholder: '请选择资金走向'
          },
          {
            selectValue: [
              { value: 'remittance', name: '线下汇款' },
              { value: 'recharge', name: '在线充值' },
              { value: 'admin_give', name: '后台赠送' },
              { value: 'buy_gold', name: '购买金币' },
              { value: 'school_teaching', name: '直播教学' },
              { value: 'school_record', name: '视频录制' },
              { value: 'school_replay', name: '视频回放' },
              // { value: 'course_ware_pack', name: '课件打包' },
              // { value: 'online_course', name: '线上课程' },
              // { value: 'online_course_ware', name: '线上课件' },
              // { value: 'offline_course', name: '线下课程' },
              // { value: 'offline_course_ware', name: '线下课件' }
            ],
            componentType: 'AppSearchStatusString',
            searchType: 'type',
            placeholder: '请选择流水类型'
          },
          { componentType: 'AppSearchColumn', searchType: column },
        ];
      },
      searchArrSecond() {
        const column = [
          { prop: 'flow_on', label: '订单号' }
        ];
        return [
          {
            componentType: 'AppSearchDate',
            searchType: 'created_at',
          },
          {
            selectValue: [
              { value: 'remittance', name: '线下汇款' },
              { value: 'recharge', name: '在线充值' },
              { value: 'admin_give', name: '后台赠送' },
              { value: 'buy_gold', name: '购买金币' },
              // { value: 'school_teaching', name: '直播教学' },
              // { value: 'school_record', name: '视频录制' },
              // { value: 'school_replay', name: '视频回放' },
              { value: 'course_ware_pack', name: '课件打包' },
              { value: 'online_course', name: '线上课程' },
              { value: 'online_course_ware', name: '线上课件' },
              { value: 'offline_course', name: '线下课程' },
              { value: 'offline_course_ware', name: '线下课件' }
            ],
            componentType: 'AppSearchStatusString',
            searchType: 'type',
            placeholder: '请选择类型'
          },
          {
            selectValue: [
              { value: 'in', name: ' 收入 ' },
              { value: 'out', name: ' 支出 ' }
            ],
            componentType: 'AppSearchStatusString',
            searchType: 'action',
            placeholder: '请选择资金走向'
          },
          { componentType: 'AppSearchColumn', searchType: column },
        ];
      },
    },
    created() {
      this.cashApiUrl = `${baseUrl}/api/expense/main/${this.school.main_id}/flow-cash`;
      this.goldApiUrl = `${baseUrl}/api/expense/main/${this.school.main_id}/flow-gold`;
      this.columns_cash =  [
        { prop: 'flow_on', label: '流水号' },
        {
          label: '类型',
          formatter: row => {
            const type = {
              'remittance': '线下汇款',
              'recharge': '在线充值',
              'admin_give': '后台赠送',
              'buy_gold': '购买金币', // 余额支付
              'school_teaching': '直播教学', // 余额支付
              'school_record': '视频录制', // 余额支付
              'school_replay': '视频回放', // 余额支付
              'course_ware_pack': '课件打包', // 余额支付
              'buy_prepaid_card': '购买预付卡'
            };
            return type[row.type]
          }
        },
        {
          label: '走向',
          formatter: row => row.action === 'in' ? '收入' : '支出'
        },
        { prop: 'created_at', label: '生成时间' },
        {
          label: '收支金额（元）',
          formatter: row => this.$setting.toDecimal(row.amount, 2)
        },
        {
          label: '支付方式',
          formatter: row => {
            const data = ['buy_gold', 'school_teaching', 'school_record', 'school_replay', 'course_ware_pack'];
            const type = {
              'remittance': '线下汇款',
              'recharge': '在线充值',
              'admin_give': '后台赠送',
              'buy_prepaid_card': '套餐支付'
            };
            return data.includes(row.type) ? '余额支付' : type[row.type]
          }
        }
      ];
      this.columns_gold =  [
        { prop: 'flow_on', label: '流水号' },
        {
          label: '类型',
          formatter: row => {
            const type = {
              'remittance': '线下汇款',
              'recharge': '在线充值',
              'admin_give': '后台赠送',
              'buy_gold': '购买金币',
              'school_teaching': '直播教学',
              'school_record': '视频录制',
              'school_replay': '视频回放',
              'course_ware_pack': '课件打包',
              'online_course': '线上课程',
              'online_course_ware': '线上课件',
              'offline_course': '线下课程',
              'offline_course_ware': '线下课件',
              'buy_prepaid_card': '购买预付卡'
            };
            return type[row.type]
          }
        },
        {
          label: '走向',
          formatter: row => row.action === 'in' ? '收入' : '支出'
        },
        { prop: 'created_at', label: '生成时间' },
        {
          label: '收支金币',
          formatter: row => this.$setting.toDecimal(row.amount, 2)
        }
      ];
    },
    methods: {
      handleClick(tab, event) {
        this.$router.push({
          query: merge(this.$route.query, { page: 1, per_page: 10 })
        })
      },
      detail(row) {
        const type = {
          // 在线充值
          'recharge': `<div>
                        <p>支付方式：${row.attach.type_text}</p>
                        <p style="margin: 10px 0;">流水号：${row.attach.trade_no}</p>
                        <p>支付日期：${row.created_at}</p>
                      </div>`,
          // 后台赠送
          'admin_give': `<div>
                            <p>支付方式：后台赠送</p>
                            <p style="margin: 10px 0;">备注：${ row.attach.remark ? row.attach.remark : '--' }</p>
                            <p style="margin: 10px 0;">支付日期：${row.created_at}</p>
                            <p>核准人：${row.attach.created_admin_name ? row.attach.created_admin_name : '--'}</p>
                          </div>`,
          // 线下汇款
          'remittance': `<div>
                            <p>支付方式：线下银行汇款</p>
                            <p style="margin: 10px 0;">汇款人/公司：${row.attach.form}</p>
                            <p style="margin: 10px 0;">汇款账号：${row.attach.account}</p>
                            <p style="margin: 10px 0;">汇款日期：${row.attach.date}</p>
                            <p>核准人：${row.attach.created_admin_name ? row.attach.created_admin_name : '--'}</p>
                          </div>`
        };
        this.$alert(
          type[row.type],
          '付款信息',
          {
          dangerouslyUseHTMLString: true
          });
      }
    }
  }
</script>

<style lang="scss" scoped>
  .water_list {

  }
</style>



// WEBPACK FOOTER //
// src/views/Waterlist/index.vue